import * as React from 'react';
import { WrappedFieldArrayProps, Field } from 'redux-form';
import { Contact } from 'src/store';
import { Table, Button } from 'antd';
import { TextField } from 'redux-form-antd';
import { RemoveButton } from 'src/components';

const required = (value: string) => (value ? undefined : 'Required');
export type DataRow = Contact & {
    no: number;
    key: string;
};

type NamedDataRow = DataRow & { name: string };

// tslint:disable-next-line:no-empty-interface
export interface Props {

}
type P = WrappedFieldArrayProps<DataRow>;

export default class ContactTable extends React.Component<P> {
    // tslint:disable-next-line
    columns: any;

    constructor(props: P) {
        super(props);

        this.columns = [
            {
                title: 'No',
                dataIndex: 'no',
                key: 'no',
                width: '5%',
                render: (text: string, record: NamedDataRow, index: number) => <span>{record.no}</span>
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                width: '20%',
                render: (text: string, record: NamedDataRow, index: number) => (
                    <Field
                        name={`${record.name}.name`}
                        component={TextField}
                        hasFeedback={false}
                        hideMessage={true}
                        validate={[required]}
                    />
                )
            },
            {
                title: 'Position',
                dataIndex: 'position',
                key: 'position',
                width: '20%',
                render: (text: string, record: NamedDataRow, index: number) => (
                    <Field
                        name={`${record.name}.position`}
                        component={TextField}
                        hasFeedback={false}
                        hideMessage={true}
                    />
                )
            },
            {
                title: 'Phone',
                dataIndex: 'phone',
                key: 'phone',
                width: '20%',
                render: (text: string, record: NamedDataRow, index: number) => (
                    <Field
                        name={`${record.name}.phone`}
                        component={TextField}
                        hasFeedback={false}
                        hideMessage={true}
                    />
                )
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
                width: '20%',
                render: (text: string, record: NamedDataRow, index: number) => (
                    <Field
                        name={`${record.name}.email`}
                        component={TextField}
                        hasFeedback={false}
                        hideMessage={true}
                    />
                )
            },
            {
                width: '1%',
                // tslint:disable-next-line:max-line-length
                title: <Button className="circle-add-button" type="primary" icon="plus" shape="circle" size="small" onClick={this.handleAdd} />,
                render: (text: string, record: DataRow, index: number) =>
                    <RemoveButton index={index} handler={this.handleRemove} />
            }
        ];
    }

    handleAdd = () => {
        const { fields } = this.props;
        const len = fields.length;

        // tslint:disable-next-line:no-any
        fields.push({
            id: 0,
            no: len + 1,
            key: len.toString(),
            name: '',
            position: '',
            phone: '',
            email: '',
        });
    }

    handleRemove = (index: number) => {
        const { fields } = this.props;
        fields.remove(index);
    }

    render() {
        const { fields } = this.props;
        const dataSource = fields.map((name, i, arr) => {
            return {
                ...arr.get(i),
                name,
            };
        });
        return (
            <Table
                dataSource={dataSource}
                pagination={false}
                columns={this.columns}
                bordered={true}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/merchants/containers/ContactTable.tsx